import { render, staticRenderFns } from "./PurchaseDeliveryRegister.vue?vue&type=template&id=bff7e63a&scoped=true&"
import script from "./PurchaseDeliveryRegister.vue?vue&type=script&lang=js&"
export * from "./PurchaseDeliveryRegister.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseDeliveryRegister.vue?vue&type=style&index=0&id=bff7e63a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff7e63a",
  null
  
)

export default component.exports